export default __webpack_public_path__ + "static/media/goopter-flashbot-building-delivery-sensors.ff9fa0ab.jpg";